import Vue from 'vue'
import Vuex from 'vuex'
import {
  STORAGE_KEYS,
  getStorageItem,
  getStorageJSON,
  getStorageNumber,
  migrateLegacyStorage,
  removeStorageItem,
  setStorageItem,
  setStorageJSON,
  setStorageNumber
} from '@/utils/storage'

Vue.use(Vuex)

migrateLegacyStorage()

const store = new Vuex.Store({
  state: {
    navIndex: 1,
    examNotice: getStorageItem(STORAGE_KEYS.EXAM_NOTICE, ''),
    examDuration: getStorageNumber(STORAGE_KEYS.EXAM_DURATION, 0),
    examStartTime: getStorageNumber(STORAGE_KEYS.EXAM_START_TIME, 0),
    userInfo: getStorageJSON(STORAGE_KEYS.USER_INFO, {})
  },
  mutations: {
    getNavIndex(state, val) {
      state.navIndex = val
    },
    setExamNotice(state, notice) {
      state.examNotice = notice
      setStorageItem(STORAGE_KEYS.EXAM_NOTICE, notice)
    },
    setExamDuration(state, duration) {
      state.examDuration = duration
      setStorageNumber(STORAGE_KEYS.EXAM_DURATION, duration)
    },
    setExamStartTime(state, timestamp) {
      state.examStartTime = timestamp
      setStorageNumber(STORAGE_KEYS.EXAM_START_TIME, timestamp)
    },
    clearExamInfo(state) {
      state.examNotice = ''
      state.examDuration = 0
      state.examStartTime = 0
      removeStorageItem(STORAGE_KEYS.EXAM_NOTICE)
      removeStorageItem(STORAGE_KEYS.EXAM_DURATION)
      removeStorageItem(STORAGE_KEYS.EXAM_START_TIME)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      setStorageJSON(STORAGE_KEYS.USER_INFO, userInfo)
    },
    clearUserInfo(state) {
      state.userInfo = {}
      removeStorageItem(STORAGE_KEYS.USER_INFO)
    }
  },
  actions: {},
  modules: {}
})

export default store
